module.exports = __webpack_public_path__ + "static/img/logo.c5632ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/logo.png
// module id = Cmp9
// module chunks = 3